export const HOME = '/notflix'
export const BROWSE = '/notflix/browse'
export const SIGN_UP = '/notflix/signup'
export const SIGN_IN = '/notflix/signin'